import { useEffect, useState } from 'react';
import { useSessionPolling } from './useSessionPolling';
import { Session } from '../dto/charger.dto';

export const useSessionById = (sessionId?: string) => {
  const [activeSession, setActiveSession] = useState<Session | undefined>(undefined);
  const [error, setError] = useState<string | undefined>(undefined);

  const { sessionData, sessionError } = useSessionPolling(
    sessionId,
    // Continue polling while session is ongoing
    !activeSession?.completeTime,
  );

  // Update session when polled data changes
  useEffect(() => {
    if (sessionData) {
      setActiveSession(sessionData);
    }
  }, [sessionData]);

  // Handle polling errors
  useEffect(() => {
    if (sessionError) {
      setError(sessionError instanceof Error ? sessionError.message : 'Failed to load session');
    } else {
      setError(undefined);
    }
  }, [sessionError]);

  return {
    activeSession,
    isLoading: sessionId !== null && !sessionData && !sessionError, // Simple loading state
    error,
  };
};
